var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"anuncios-index ml-4 mt-3"},[_c('tabs',{staticClass:"mx-0",attrs:{"tabs":_vm.arrayTabs}}),_c('router-view',{staticClass:"router-view-anuncios mt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }